import cx from 'classnames';
import { useRef } from 'react';

import { useAnimation } from '../../hooks/useAnimation';

import styles from '../../styles/modules/tasks/Tasks.module.scss';
import awardStyles from '../../styles/modules/tasks/TasksAward.module.scss';

import Icon from '../icon/Icon';
import TaskButton from './TaskButton';

import { BASE_URL, EVENT_AWARD_TYPES, TASKS_CLASSES } from '../../utils/constants';

const tasks = [
	{
		level: 59,
		title: 'Лучше некуда',
		class: 'disabled',
		point_cost: 2086,
		description: '',
		button: [],
		award: {
			type: 'COINS',
			points: 250,
			prizes: 1,
			amount: '10000',
		},
	},
	{
		level: 60,
		title: 'Конец пути',
		class: 'special-yellow disabled',
		point_cost: 2745,
		description: '',
		button: [],
		award: {
			type: 'CASE',
			points: 500,
			prizes: 1,
			name: 'sekretnaya-nagrada',
			title: 'Секретная награда',
			amount: '39999₽',
		},
	},
	{
		level: 1,
		title: 'Игро-тестер',
		class: 'available',
		point_cost: 5,
		description: 'Cыграть 1 раз в бесплатную мини-игру',
		icon: '/assets/img/event/winter2025/tasks/game.webp?v=1',
		button: {
			icon: 'gift_open',
			href: '/event#battle',
			target: '_self',
		},
		award: {
			type: 'COINS',
			points: 10,
			prizes: 1,
			icon: '/assets/img/event/winter2025/awards/coin.webp?v=1',
			amount: '250',
		},
		weight_cur: 0,
		weight_max: 1,
		pointCur: 0,
	},
	{
		level: 2,
		title: 'Твой первый',
		class: 'disabled',
		point_cost: 15,
		description: '',
		icon: '/assets/img/cases/ab6411bcbe460140521f74da7ca8e3e5e685.webp',
		button: [],
		award: {
			type: 'COINS',
			points: 5,
			prizes: 1,
			icon: '/assets/img/event/winter2025/awards/coin.webp?v=1',
			amount: '50',
		},
	},
	{
		level: 3,
		title: 'Твое новое имя',
		class: 'disabled',
		point_cost: 15,
		description: '',
		icon: '/assets/img/event/winter2025/tasks/nickname.webp?v=1',
		button: [],
		award: {
			type: 'COINS',
			points: 5,
			prizes: 1,
			icon: '/assets/img/event/winter2025/awards/coin.webp?v=1',
			amount: '50',
		},
	},
];

const Tasks = () => {
	const userLevel = 1;

	const { COINS } = EVENT_AWARD_TYPES;
	const { CHECKED, AVAILABLE } = TASKS_CLASSES;

	const sfRef = useRef(null);
	const arcanaRef = useRef(null);

	useAnimation({
		ref: sfRef,
		name: 'sf',
		viewport: {
			x: -1500,
			y: -810,
			width: 2300 * 1.25,
			height: 2240 * 1.25,
		},
	});

	useAnimation({
		ref: arcanaRef,
		name: 'arcana',
	});

	return (
		<div className={styles.container}>
			<div className={styles.content}>
				<div className={cx(styles.award, styles.left, styles.green)}>
					<div ref={arcanaRef} className={cx(styles.animation, styles.arcana)} />

					<div className={styles.awardTitle}>
						<p>награда за 15 лвл</p>
						<p></p>
					</div>
				</div>
				<div className={styles.missions}>
					<p className={styles.missionsTitle}>Или выполняй задания Battle Pass</p>

					<div className={styles['missions-list']}>
						{tasks.map(
							(
								{
									award: { title: awardTitle, type, amount, points },
									weight_cur: currentWeight,
									weight_max: maxWeight,
									class: taskClassName,
									description,
									level,
									title,
								},
								idx,
							) => {
								const iconName = taskClassName.includes(CHECKED) ? 'check' : 'lock';

								const classes = taskClassName
									.split(' ')
									.map((cls) => styles[cls])
									.filter(Boolean)
									.join(' ');

								const isActive = userLevel === level;

								const width = maxWeight > 1 ? (currentWeight * 100) / maxWeight : 0;
								const overlay = 100 - width;
								const completed = overlay <= 1;

								const key = `${level}-${title}-${idx}`;

								return (
									<div
										className={cx(`${styles.task} ${classes}`, {
											[styles.full]: isActive,
										})}
										data-active='false'
										key={key}
									>
										{isActive ? (
											<div
												className={cx(`${styles['missions-item']} ${classes}`, {
													[styles.full]: isActive,
												})}
												data-active='true'
											>
												<div className={styles.missionContent}>
													<div className={styles['missions-icon']}>
														{taskClassName !== AVAILABLE && (
															<Icon name={iconName} className={styles[iconName]} />
														)}
													</div>

													<div className={cx(styles['missions-icon'], styles['missions-lvl'])}>
														<span>{level}</span>
													</div>

													<div className={styles['missions-headling']}>
														<div className={styles['missions-title']}>{title}</div>

														<p
															className={awardStyles['mission-description']}
															dangerouslySetInnerHTML={{ __html: description }}
														/>
													</div>

													{maxWeight && (
														<div className={cx(awardStyles.progressbar, styles.progressbar)}>
															<p>
																<span className={awardStyles.current}>{currentWeight}</span>
																<span className={awardStyles.total}> из {maxWeight}</span>
															</p>
															<div className={awardStyles.progress}>
																{!!width && (
																	<span
																		className={cx(awardStyles.fill, {
																			[awardStyles.visible]: completed,
																		})}
																		style={{ width: `${width}%` }}
																	/>
																)}
															</div>
														</div>
													)}

													<TaskButton className={cx(awardStyles.button, styles.missionButton)} />
												</div>

												<div className={styles.missionAward}>
													<div className={styles.missionAwardTitle}>Награды</div>
													<div className={styles.missionAwardImage}>
														<img
															src={require('../../assets/images/cases/award.webp')}
															alt=''
															loading='lazy'
														/>
													</div>
													<div className={styles.missionAwardHeadling}>{awardTitle}</div>
													<div className={styles.missionAwardInfo}>
														<span />
														<p>
															{level} → {level + 1} LVL
														</p>
														<div className={styles.missionAwardXP}>
															<Icon name='xp' />
															<p>{points}</p>
														</div>
													</div>
												</div>
											</div>
										) : (
											<div
												className={cx(`${styles['missions-item']} ${classes}`, {
													[styles.full]: isActive,
												})}
												data-active='false'
											>
												<div className={styles['missions-icon']}>
													{taskClassName !== AVAILABLE && (
														<Icon name={iconName} className={styles[iconName]} />
													)}
												</div>

												<div className={cx(styles['missions-icon'], styles['missions-lvl'])}>
													<span>{level}</span>
												</div>

												<div className={styles.lockIcon}>
													<Icon name={`transparent-${iconName}`} className={styles[iconName]} />
												</div>

												<div className={styles['missions-image']}>
													<img
														src={require(`../../assets/images/cases/${level}.webp`)}
														alt=''
														loading='lazy'
													/>
												</div>

												<div className={styles['missions-title']}>{title}</div>

												<div className={styles['missions-subtitle']}>
													<span>Награда: </span>
													{type === COINS ? (
														<p>
															<span>ЭПИК КОИНЫ</span> <span>{amount}</span> <Icon name='coins' />
														</p>
													) : (
														<p>
															{awardTitle} за {amount}
														</p>
													)}
												</div>
											</div>
										)}
									</div>
								);
							},
						)}
					</div>
				</div>

				<div className={cx(styles.award, styles.right, styles.yellow)}>
					<div ref={sfRef} className={cx(styles.animation, styles.sf)} />

					<div className={styles.awardTitle}>
						<p>награда за 60 лвл</p>
						<p></p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Tasks;
